module.exports = __webpack_public_path__ + "static/img/f1.5aca576.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd108/f1.png
// module id = 1BvS
// module chunks = 1